export const netBillState =
{
    totalBill: 0,
}
